import Component from '../inherited/Component'
import AjaxApi from '../lib/AjaxApi'
import Helpers from '../lib/Helpers'

let rivets = null

export default class BundleBuilder extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._jsonElems = this._elem.querySelectorAll('[data-bundle-builder-json]')
    this._data = {
      ...{
        loading: true,
        addingItems: false,
        stages: [],
        current_step: 0,
        cart: {
          items: [],
          item_count: 0
        },
        all_products_to_display: [],
        products_to_display: [],
        products_to_recommend: {},
        selected_products: localStorage.BB_SAVED_BUNDLE && localStorage.BB_SAVED_BUNDLE.length > 0 ? JSON.parse(localStorage.BB_SAVED_BUNDLE) : [],
        display_results: {},
        ometria: {},
        saved_for_later: localStorage.BB_SAVED_BUNDLE && localStorage.BB_SAVED_BUNDLE.length > 0 ? true : false,
        overflow_type: this._elem.querySelector('[data-overflow-type]').dataset.overflowType,
        svgs: {
          tick: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m19.19 5.812-.188-.165-.165.188-9.459 10.743-4.197-4.968-.162-.191-.19.162-.99.839-.191.161.161.19 5.355 6.34.187.222.192-.217L20.188 7.023l.165-.187-.188-.166-.976-.858z" fill="#7FA17E" stroke="#7FA17E" stroke-width=".5"/></svg>`
        }
      } 
    }

    this._binded = null
  } 

  _binders () {
    rivets.formatters.eq = (arg1, arg2) => {
      return arg1 === arg2
    }

    rivets.formatters.add = function(target, val) {
      return target + val
    }

    rivets.formatters.money = (value) => {
      if (value > 0) {
        return Helpers.formatMoney(value, this._ctx.getState().moneyFormat)
      } else {
        return this._ctx.getState().locale.free
      }
    }

    rivets.formatters.getSizedImage = (src, size) => {
        return src ? Helpers.getSizedImageUrl(src, size) : ''
    } 

    rivets.formatters.getTick = (value, message) => {
        return value && message ? (value.toLowerCase() === message.toLowerCase() ? this._data.svgs.tick : '') : value
    }

    rivets.formatters.not = (value) => {
        return !value
    }
  }

  async mount () {
    this._doEditorListeners();

    rivets = await import('rivets')
    
    for (let jsonElem of this._jsonElems) {
      this._data.stages.push(JSON.parse(jsonElem.innerHTML))
    }

    this._binders()

    this._data = await this._prepareData(this._data)

    this._binded = rivets.bind(this._elem, this._getModel())

    this._elem.classList.add('rendered')

    if (this._data.selected_products.length > 0) {
      await this._prepareResults(this._data)
      this._prepareCart(this._data)
      this._data.current_stage = this._data.stages[3]
    }
  }


  _doEditorListeners () {
    document.addEventListener('shopify:section:select', e => {
      let currentStepObj = JSON.parse(e.target.querySelector('[data-bundle-builder-json]').innerHTML)
      
      this._data.currentStep = currentStepObj.currentStep
      this._data.currentStepObj = this._data.steps[this._data.currentStep]
      
      if (this._data.overflow_type == 'slider') {
        document.dispatchEvent(new Event('BB-slider-reinit'))
      }
    })

    document.addEventListener('shopify:section:deselect', e => {
      this._data.currentStep = 0
      this._data.currentStepObj = this._data.steps[this._data.currentStep]

      if (this._data.overflow_type == 'slider') {
        document.dispatchEvent(new Event('BB-slider-reinit'))
      }
    })
  }

  async _prepareData (data) {
    data.current_stage = this._data.stages[0]

    data.current_step_title = this._data.stages[2].steps[0].step_title
    data.current_step_is_required = this._data.stages[2].steps[0].is_required
    data.current_step_header_title = this._data.stages[2].steps[0].header_title
    data.stages[2].header.title = data.current_step_header_title
    // data.stages[2].header.text = 'Step ' + (data.current_step + 1) + '  / ' + this._data.stages[2].steps.length
    data.stages[2].header.text = ''

    data.total_steps = this._data.stages[2].steps.length - 1

    let products_to_display_handles = []
    let all_products_to_display = []
    let products_to_display = []
    let promises = []

    for (let step of data.stages[2].steps) {
      products_to_display = []
      products_to_display_handles = step.products_to_compare

      for (let [index, product_handle] of products_to_display_handles.entries()) {
        promises.push(new Promise(async (res, rej) => {
          try{
            let handle = product_handle.product_handle
            let variant = product_handle.product_variant
            let productData = await AjaxApi.getCustomProduct(handle)

            productData.step = step
                        
            if (variant) {
              productData.variant = variant
            }

            products_to_display[index] = productData

            res()
          } catch (e) {
            rej(e)
          }
        }))
      }

      products_to_display = products_to_display.filter(Boolean)
      await Promise.all(promises)
      all_products_to_display.push(products_to_display)
    }

    data.all_products_to_display = all_products_to_display
    data.products_to_display = all_products_to_display[0]
    data.loading = false
    
    if (this._data.overflow_type == 'slider') {
      document.dispatchEvent(new Event('BB-slider-reinit'))
    }

    console.log(data)

    return data
  }

  _getModel () {
    return {
      data: this._data,
      controller: {
        nextStage: (e, model) => {
          e.preventDefault()

          let currentStageOrder = model.data.current_stage.stage_order
          let nextStageOrder = currentStageOrder + 1

          // assign recommended products after answere were selected
          if (nextStageOrder == 2) {
            for (let [prod_step, prod_handle] of Object.entries(model.data.products_to_recommend)) {
              for (let item of model.data.all_products_to_display) {
                for (let subitem of item) {
                  if (subitem.step.step == prod_step && subitem.product.handle == prod_handle) {
                    subitem.recommended = true
                  }
                }
              }
            }
          }

          if (this._data.overflow_type == 'slider') {
            document.dispatchEvent(new Event('BB-slider-unmount'))
          }

          model.data.current_stage = model.data.stages[nextStageOrder] ? model.data.stages[nextStageOrder] : model.data.stages[currentStageOrder]

          if (this._data.overflow_type == 'slider') {
            document.dispatchEvent(new Event('BB-slider-mount'))
          } else {
            this._doubleScroll()
          }

          console.log(model.data)
        },
        nextStageResults: async (e, model) => {
          e.preventDefault()
          
          await this._prepareResults(model.data)
          this._prepareCart(model.data)

          model.data.current_stage = model.data.stages[3]
        },
        nextStep: (e, model) => {
          e.preventDefault()

          if (this._data.overflow_type == 'slider') {
            document.dispatchEvent(new Event('BB-slider-unmount'))
          }

          let current_step = model.data.current_step
          let next_step = current_step + 1

          model.data.products_to_display = model.data.all_products_to_display[next_step]
          model.data.current_step = model.data.current_stage.questions[next_step] ? next_step : current_step

          model.data.current_step_title = model.data.current_stage.steps[next_step] ? model.data.current_stage.steps[next_step].step_title : model.data.current_step_title
          model.data.current_step_is_required = model.data.current_stage.steps[next_step] ? model.data.current_stage.steps[next_step].is_required : model.data.current_step_is_required
          model.data.current_step_header_title = model.data.current_stage.steps[next_step] ? model.data.current_stage.steps[next_step].header_title : model.data.current_step_header_title
          model.data.current_stage.header.title = model.data.current_step_header_title
          // model.data.current_stage.header.text = 'Step ' + (model.data.current_step + 1) + '  / ' + model.data.current_stage.steps.length
          model.data.current_stage.header.text = ''

          model.data.current_stage.selected_product = {}

          if (this._data.overflow_type == 'slider') {
            document.dispatchEvent(new Event('BB-slider-mount'))
          } else {
            this._doubleScroll()
          }
          
          for (let radio of document.querySelectorAll('.bundle-builder-product-item input[type="radio"]')) {
            radio.checked = false
          }
        },
        setAnswer: (e, model) => {
          let prod = e.target.value
          let product_handle = prod.split('|')[0]
          let step = prod.split('|')[1]
          
          model.data.products_to_recommend[step] = ''
          model.data.products_to_recommend[step] = product_handle

          model.data.current_stage.all_answers_checked = false
          if (Object.keys(model.data.products_to_recommend).length >= model.data.current_stage.questions.length) model.data.current_stage.all_answers_checked = true
        },
        setSelectedProduct: (e, model) => {
          let product_handle = e.target.value
          let product_title = e.target.dataset.productTitle
          let product_step = model.data.current_step
          let product_variant = e.target.dataset.productVariant

          let set_obj = model.data.current_stage.steps[product_step]
          set_obj.selected_handle = product_handle

          model.data.current_stage.selected_product = {}
          model.data.current_stage.selected_product.handle = product_handle
          model.data.current_stage.selected_product.title = product_title
          model.data.current_stage.selected_product.step = product_step
          model.data.current_stage.selected_product.variant = product_variant
          
          let selected_product = {
            'product_handle': product_handle,
            'product_title': product_title,
            'product_step': product_step,
            'product_variant': product_variant
          }

          if (e.target.checked == true) {
            model.data.selected_products = model.data.selected_products.filter(prod => prod.product_step !== product_step)
            model.data.selected_products.push(selected_product)
          } else {
            let i = model.data.selected_products.indexOf(selected_product)
            if (i > -1) {
              model.data.selected_products.splice(i, 1)
            }
          }
        },
        returnToStep: async (e, model) => {
          if (this._data.overflow_type == 'slider') {
            document.dispatchEvent(new Event('BB-slider-unmount'))
          }

          let stage = model.data.stages[2]
          let step = Number(e.target.closest('.bundle-builder-item').dataset.questionStep)

          model.data.saved_for_later = false
          model.data.selected_products.length = step
          model.data.display_results = {}

          stage.selected_product = {}

          model.data.current_stage = stage
          
          model.data.current_step = step
          model.data.current_step_title = stage.steps[step].step_title
          model.data.current_step_is_required = stage.steps[step].is_required
          model.data.current_step_header_title = stage.steps[step].header_title
          model.data.stages[2].header.title = model.data.current_step_header_title
          model.data.stages[2].header.text = 'Step ' + (step + 1) + '  / ' + stage.steps.length
          model.data.products_to_display = model.data.all_products_to_display[step]

          if (this._data.overflow_type == 'slider') {
            document.dispatchEvent(new Event('BB-slider-mount'))
          } else {
            this._doubleScroll()
          }

          let radios = this._elem.querySelectorAll('.bundle-builder-product-item input[data-product-variant]')

          for (let radio of radios) {
            radio.checked = false
            radio.dispatchEvent(new Event('change'))
          }

          console.log(model.data)
        },
        saveForLater: async (e, model) => {
          localStorage.BB_SAVED_BUNDLE = JSON.stringify(model.data.selected_products)
          this._data.saved_for_later = true

          this._ctx.emit('BB-builder-builder-save')
        },
        startAgain: (e, model) => {
          e.preventDefault()

          localStorage.removeItem('BB_SAVED_BUNDLE')
          window.scrollTo(0,0)
          location.reload()
        },
        addToCart: async (e, model) => {
          e.preventDefault()

          this._data.addingItems = true

          let itemsToAdd = {
            items: [],
          }

          for (let item of model.data.display_results.products) {
            let cartItem = {}

            let variant = item.product.variants.find(variant => variant.price === item.product.price_max) || item.product.variants[0]
            let variant_id = variant.id

            console.log('++')
            console.log(item)
            
            if (item.variant) {
              for (let variant of item.product.variants) {
                if (variant.id == item.variant && variant.available) {
                  variant_id = item.variant
                }
              }
            }

            console.log(variant_id)

            cartItem.id = variant_id
            cartItem.quantity = 1
            cartItem.properties = {'_bundle-text': this._options.bundleText}

            itemsToAdd.items.push(cartItem)
          }

          await AjaxApi.addToCart(itemsToAdd)

          model.data.ometria['coprobdate'] = new Date()

          localStorage.removeItem('BB_SAVED_BUNDLE')
          localStorage.setItem('BB_OMETRIA_BUNDLE', JSON.stringify(model.data.ometria))
          
          this._ctx.emit('cart-item-added')
          this._ctx.on('cart-item-added--refreshed', () => {
            this._data.addingItems = false
            model.data.cart.items = []
            model.data.cart.item_count = 0
          })
        }
      }
    }
  }

  async _prepareResults (data) {
    let results = []
    let promises = []

    for (let [index, product] of data.selected_products.entries()) {
      promises.push(new Promise(async (res, rej) => {
        try{
          let handle = product.product_handle
          let variant = product.product_variant
          let productData = await AjaxApi.getCustomProduct(handle)
                      
          if (variant) {
            productData.variant = variant
          }

          productData.step = product.product_step

          results[index] = productData

          res()
        } catch (e) {
          rej(e)
        }
      }))
    }

    results = results.filter(Boolean)
    await Promise.all(promises)

    data.display_results.products = results
  }


  _prepareCart (data) {
    let total_price = 0

    for (let item of data.display_results.products) {
      if (item.variant) {
        for (let variant of item.product.variants) {
          if (variant.id == item.variant && variant.available) {
            total_price += variant.price
          }
        }
      } else {
        total_price += item.product.variants[0].price
      }
    }

    data.display_results.total_price = total_price
    data.display_results.total_save = (data.stages[3].discount_percent/100) * total_price
    data.display_results.total_price_discounted = total_price - data.display_results.total_save
    data.display_results.total_save_percents = data.stages[3].discount_percent
  }

  _doubleScroll () {
    let element = document.querySelector('.products-slider')
    let scrollbar = document.querySelector('.details-slider')

    if (!scrollbar || !element) return

    scrollbar.style.width = element.scrollWidth + 'px'
    scrollbar.classList.add('double-scrollbar')
    scrollbar.appendChild(document.createTextNode('\xA0'))

    scrollbar.onscroll = function() {
      element.scrollLeft = scrollbar.scrollLeft
    }
    element.onscroll = function() {
      scrollbar.scrollLeft = element.scrollLeft
    }
  }
}